<template>
  <div v-if="show" class="loading-status">
    <img src="../assets/img/global/bell-loader-anim.gif" />
    <!--
    <div class="loading-status--circle">loading</div>
    -->
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    show: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/environment/_variables";

.loading-status {
  margin: 20px 0;
  text-align: center;

  img {
    position: absolute;
    top: 19px;
    right: 17px;
    width: 55px;
    //opacity: 85%;
  }

  .loading-status--circle {
    font-size: 0;
    text-indent: -9999em;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: $sa-white;
    background: linear-gradient(to right, #8f8f8f 10%, rgba(143, 143, 143, 0) 42%);
    position: relative;
    animation: anim-rotate 0.8s infinite linear;
    transform: translateZ(0);
    margin: 0 auto;

    &::before {
      width: 50%;
      height: 50%;
      background: #8f8f8f;
      border-radius: 100% 0 0 0;
      position: absolute;
      top: 0;
      left: 0;
      content: '';
    }

    &::after {
      background: $sa-white;
      width: 75%;
      height: 75%;
      border-radius: 50%;
      content: '';
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }
}

@keyframes anim-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>

